import React from 'react';
import PropTypes from 'prop-types';
import ExternalLinkWrapper from '../../../../navigation/ExternalLinkWrapper';
import { FAQ } from '../../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const FAQSection = ({ FAQList }) => (
    <div className="section faq-section">
        <h3 className="section-name">{FAQ}</h3>
        {FAQList.map((question, index) => (
            <div key={generateReactKey(index)} className="wrap">
                <ExternalLinkWrapper
                    content={question.title}
                    path={question.url}
                    className="description underline-text"
                />
            </div>
        ))}
    </div>
);

FAQSection.defaultProps = {
    FAQList: [],
};

FAQSection.propTypes = {
    FAQList: PropTypes.array,
};

export default FAQSection;
